export default __webpack_public_path__ + "static/media/DINE-IN.ed1b2e68.svg";